import React, { useState } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

// Import Chart
import SupportTrend from "./SupportTrend";
import TotalSupportWidget from "./SupportTrend/TotalSupportWidget";
import AligningWidget from "./SupportTrend/AligningWidget";
import TotalMDAsWidget from "./SupportTrend/TotalMDAsWidget";

const Marketplace = () => {
  const [activeTab, setActiveTab] = useState<string>("number");

  return (
    <React.Fragment>
      <Row>
        <Col xxl={12}>
          <Card className="card-height-100">
            <CardBody className="p-0">
              <Row className="g-0">
                <Col xxl={12}>
                  <div className="pb-4">
                    <CardHeader className="border-0 align-items-center d-flex">
                      <h4 className="card-title mb-0 flex-grow-1">
                        Trend of Capacity Injection Support by Year
                      </h4>
                      <div className="d-flex gap-1">
                        <button
                          type="button"
                          className={`btn btn-sm material-shadow-none ${
                            activeTab === "number"
                              ? "btn-soft-primary"
                              : "btn-soft-secondary"
                          }`}
                          onClick={() => {
                            setActiveTab("number");
                          }}
                        >
                          NUMBER
                        </button>
                        <button
                          type="button"
                          className={`btn btn-sm material-shadow-none ${
                            activeTab === "amount"
                              ? "btn-soft-primary"
                              : "btn-soft-secondary"
                          }`}
                          onClick={() => {
                            setActiveTab("amount");
                          }}
                        >
                          AMOUNT
                        </button>

                        {/* <button
                          type="button"
                          className="btn btn-soft-secondary btn-sm material-shadow-none"
                          onClick={() => {
                            onChangeChartPeriod("halfyear");
                          }}
                        >
                          6M
                        </button>
                        <button
                          type="button"
                          className="btn btn-soft-primary btn-sm material-shadow-none"
                          onClick={() => {
                            onChangeChartPeriod("year");
                          }}
                        >
                          1Y
                        </button> */}
                      </div>
                    </CardHeader>
                    <Row className="g-0 text-center">
                      <Col sm={4} className="col-6">
                        <TotalSupportWidget activeTab={activeTab} />
                      </Col>
                      <Col sm={4} className="col-6">
                        <AligningWidget activeTab={activeTab} />
                      </Col>
                      <Col sm={4} className="col-6">
                        <TotalMDAsWidget activeTab={activeTab} />
                      </Col>
                    </Row>
                    <SupportTrend activeTab={activeTab} />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Marketplace;
